import { AxiosError } from "axios";
import { useCallback, useState } from "react";
import useGetPositionsOrVirtualPortfolioPlanStatsOriginal from "../../Investment/hooks/useGetPositionsOrVirtualPortfolioPlanStats";
import { FinMasonError, } from "../../Investment/types";
function useGetTransitionalProposalPlanStats(auth) {
    const getPositionsOrVirtualPortfolioPlanStats = useGetPositionsOrVirtualPortfolioPlanStatsOriginal(auth);
    const [portfolioStats, setPortfolioStats] = useState(undefined);
    const [isLoadingPortfolioStats, setIsLoadingPortfolioStats] = useState(false);
    const [hasPortfolioStatsError, setHasPortfolioStatsError] = useState(false);
    const [hasFinMasonError, setHasFinMasonError] = useState();
    const [invalidPositions, setInvalidPositions] = useState([]);
    const reset = useCallback(() => {
        setPortfolioStats(undefined);
        setIsLoadingPortfolioStats(false);
        setHasPortfolioStatsError(false);
        setInvalidPositions([]);
    }, []);
    const fetchPortfolioStats = useCallback(async (data) => {
        setPortfolioStats(undefined);
        setIsLoadingPortfolioStats(true);
        if ((data.type === "positions" && data.positions.length === 0) ||
            (data.type === "virtual_portfolio_plan" &&
                data.virtualPlan.entries.length === 0)) {
            setIsLoadingPortfolioStats(false);
            return;
        }
        setHasPortfolioStatsError(false);
        try {
            const response = await getPositionsOrVirtualPortfolioPlanStats(data.type === "virtual_portfolio_plan"
                ? {
                    ...data,
                    virtualPlan: {
                        ...data.virtualPlan,
                        transformers: [],
                    },
                }
                : data);
            if (response instanceof FinMasonError) {
                setHasPortfolioStatsError(true);
            }
            else {
                setPortfolioStats(response);
            }
        }
        catch (error) {
            setHasPortfolioStatsError(true);
            // Extract invalid positions from error response if available
            if (data.type === "positions" && error instanceof AxiosError) {
                const invalidPositionsData = error.response?.data?.details?.invalidPositions;
                if (typeof invalidPositionsData === "object" &&
                    invalidPositionsData !== null) {
                    setInvalidPositions(Object.keys(invalidPositionsData).map((key) => key.replace("ticker:", "").replace("cusip:", "")));
                }
            }
        }
        finally {
            setIsLoadingPortfolioStats(false);
        }
    }, [getPositionsOrVirtualPortfolioPlanStats]);
    const retryWithFilteredPositions = useCallback(async (data) => {
        if (data.positions.length === 0 || invalidPositions.length === 0) {
            return;
        }
        setIsLoadingPortfolioStats(true);
        setHasPortfolioStatsError(false);
        try {
            const filteredPositions = data.positions.filter((position) => !invalidPositions.includes(position?.ticker || position?.cusip || ""));
            const response = await getPositionsOrVirtualPortfolioPlanStats({
                type: "positions",
                positions: filteredPositions,
            });
            if (response instanceof FinMasonError) {
                setHasPortfolioStatsError(true);
            }
            else {
                setPortfolioStats(response);
            }
        }
        catch (e) {
            if (e instanceof FinMasonError) {
                setHasFinMasonError(e);
            }
            setHasPortfolioStatsError(true);
        }
        finally {
            setIsLoadingPortfolioStats(false);
        }
    }, [getPositionsOrVirtualPortfolioPlanStats, invalidPositions]);
    return {
        isLoadingPortfolioStats,
        hasPortfolioStatsError,
        portfolioStats,
        invalidPositions,
        fetchPortfolioStats,
        reset,
        retryWithFilteredPositions,
        hasFinMasonError,
    };
}
export default useGetTransitionalProposalPlanStats;
//# sourceMappingURL=useGetTransitionalProposalPlanStats.js.map